import type { ReactNode } from "react";
import { Icon, type IconName } from "../../icons";

export interface EmptyStateProps {
  icon?: IconName;
  title: string;
  description?: ReactNode;
  action?: ReactNode;
}

export function EmptyState({ icon = "inbox", title, description, action }: EmptyStateProps): React.JSX.Element {
  return (
    <div className="nb-empty">
      <span className="nb-empty-icon">
        <Icon name={icon} />
      </span>
      <p className="nb-empty-title">{title}</p>
      {description ? <p className="nb-empty-text">{description}</p> : null}
      {action ? <div className="nb-empty-action">{action}</div> : null}
    </div>
  );
}
